import {
    ADD_PATIENT_REQUEST,
    ADD_PATIENT_SUCCESS,
    ADD_PATIENT_FAILURE,
    GET_PATIENT_LIST_REQUEST,
    GET_PATIENT_LIST_SUCCESS,
    GET_PATIENT_LIST_FAILURE,
    ADD_BOOKING_REQUEST,
    ADD_BOOKING_SUCCESS,
    ADD_BOOKING_FAILURE,
    DELETE_PATIENT_REQUEST,
    DELETE_PATIENT_SUCCESS,
    DELETE_PATIENT_FAILURE,
    EDIT_PATIENT_REQUEST,
    EDIT_PATIENT_SUCCESS,
    EDIT_PATIENT_FAILURE,
    UPDATE_GUIDE_REQUEST,
    UPDATE_GUIDE_SUCCESS,
    UPDATE_GUIDE_FAILURE,
    GET_CASE_DETAILS_REQUEST,
    GET_CASE_DETAILS_SUCCESS,
    GET_CASE_DETAILS_FAILURE,
    ADD_PICKUP_REQUEST,
    ADD_PICKUP_SUCCESS,
    ADD_PICKUP_FAILURE,
    GET_PARENT_CASES_FAILURE,
    GET_PARENT_CASES,
    GET_PARENT_CASES_SUCCESS,
    SET_FILTER_VALUES_DENTIST
} from './constants';

export function addPatient(data) {
    return {
        type: ADD_PATIENT_REQUEST,
        data: data
    }
}

export function addPatientSuccess(response) {
    return {
        type: ADD_PATIENT_SUCCESS,
        data: response
    }
}

export function addPatientFailure() {
    return {
        type: ADD_PATIENT_FAILURE,
        data: {}
    }
}

export function getPatient(data) {
    return {
        type: GET_PATIENT_LIST_REQUEST,
        data
    }
}

export function getPatientSuccess(response) {
    return {
        type: GET_PATIENT_LIST_SUCCESS,
        data: response
    }
}

export function getPatientFailure() {
    return {
        type: GET_PATIENT_LIST_FAILURE,
        data: {}
    }
}

export function addBooking(data) {
    return {
        type: ADD_BOOKING_REQUEST,
        data: data
    }
}

export function addBookingSuccess(response) {
    return {
        type: ADD_BOOKING_SUCCESS,
        data: response
    }
}

export function addBookingFailure(error) {
    return {
        type: ADD_BOOKING_FAILURE,
        data: error
    }
}

export function deletePatient(patientId, data) {
    return {
        type: DELETE_PATIENT_REQUEST,
        data: {patientId, data}
    }
}

export function deletePatientSuccess(response) {
    return {
        type: DELETE_PATIENT_SUCCESS,
        data: response
    }
}

export function deletePatientFailure(error) {
    return {
        type: DELETE_PATIENT_FAILURE,
        data: error
    }
}

export function editPatient(data) {
    return {
        type: EDIT_PATIENT_REQUEST,
        data: data
    }
}

export function editPatientSuccess(response) {
    return {
        type: EDIT_PATIENT_SUCCESS,
        data: response
    }
}

export function editPatientFailure(error) {
    return {
        type: EDIT_PATIENT_FAILURE,
        data: error
    }
}

export function updateGuide() {
    return {
        type: UPDATE_GUIDE_REQUEST
    }
}

export function updateGuideSuccess(response) {
    return {
        type: UPDATE_GUIDE_SUCCESS,
        data: response
    }
}

export function updateGuideFailure(error) {
    return {
        type: UPDATE_GUIDE_FAILURE,
        data: error
    }
}

export function getCase(caseId) {
    return {
        type: GET_CASE_DETAILS_REQUEST,
        caseId: caseId
    }
}

export function getCaseSuccess(response) {
    return {
        type: GET_CASE_DETAILS_SUCCESS,
        data: response
    }
}

export function getCaseFailure() {
    return {
        type: GET_CASE_DETAILS_FAILURE,
        data: {}
    }
}

export function addPickup(caseId, isPickup) {
    return {
        type: ADD_PICKUP_REQUEST,
        data: {caseId, isPickup}
    }
}

export function addPickupSuccess(response) {
    return {
        type: ADD_PICKUP_SUCCESS,
        data: response
    }
}

export function addPickupFailure() {
    return {
        type: ADD_PICKUP_FAILURE,
        data: {}
    }
}

export function getParentCases() {
    return {
        type: GET_PARENT_CASES
    }
}

export function getParentCasesSuccess(response) {
    return {
        type: GET_PARENT_CASES_SUCCESS,
        data: response
    }
}

export function getParentCasesFailure() {
    return {
        type: GET_PARENT_CASES_FAILURE,
        data: {}
    }
}

export function setFilterValuesSuccessDentist(data){
    return {
        type: SET_FILTER_VALUES_DENTIST,
        data,
    }
} 


// WEBPACK FOOTER //
// ./src/containers/Layouts/User/Home/actions.js